// @flow

// Material-UI theme
import getMuiTheme from "material-ui/styles/getMuiTheme";
import spacingExtender from "./spacingExtender";
import colors from "./colors";

const styledComponentTheme = {
  bottom: {
    backgroundColor: colors.darkBlue
  },
  button: {
    fontFamily: "Gotham A, Arial, sans-serif",
    primaryBackgroundColor: colors.maroon,
    secondaryBackgroundColor: colors.white,
    primaryColor: colors.lightRose,
    secondaryColor: colors.maroon,
    shadow: `0 2px 5px 0 ${colors.redShadow}`,
    fontWeight: 300,
    disabledColor: colors.darkGrey,
    selectedShadow: `0 8px 20px 0 ${colors.redShadow}`,
    primarySelectedColor: colors.white
  },
  fonts: {
    normalFontColor: colors.black,
    family: {
      bookText: "Gotham A, Arial, sans-serif",
      lightText: "Gotham A, Arial, sans-serif",
      mediumText: "Gotham A, Arial, sans-serif",
      boldText: "Gotham A, Arial, sans-serif"
    },
    weight: {
      bookText: 400,
      lightText: 300,
      mediumText: 500,
      boldText: 700
    },
    sizes: {
      Text1: "27px",
      Text2: "24px",
      Text3: "16px",
      Text4: "14px",
      Text5: "12px",
      Text6: "10px"
    }
  },
  forms: {
    padding: "56px"
  },
  header: {
    height: "60px"
  },
  links: {
    primaryColor: colors.black,
    secondaryColor: colors.blue
  },
  mainBackground: colors.whiteGrey,
  shadow: `0 2px 10px 0 ${colors.greyShadow}`,
  textInput: {
    fontFamily: "Gotham A, Arial, sans-serif",
    fontWeight: 400,
    borderColor: colors.mediumDarkGrey,
    marginBottom: "30px",
    fontSize: "14px"
  },
  spacingExtender,
  colors
};

const materialUITheme = getMuiTheme({
  checkbox: {
    checkedColor: "rgb(0, 0, 0)"
  },
  fontFamily: "Gotham A, Arial, sans-serif",
  fontWeight: 500,
  stepper: {
    connectorLineColor: "#7B2431",
    iconColor: "#7B2431",
    disabledTextColor: "#7B2431",
    borderColor: "#7B2431",
    inactiveIconColor: "#fff"
  },
  borderRadius: 5,
  selectField: {
    borderColor: colors.mediumDarkGrey,
    fontFamily: styledComponentTheme.fonts.family.bookText,
    fontWeight: styledComponentTheme.fonts.weight.bookText,
    fontSize: styledComponentTheme.fonts.sizes.Text4,
    largeFontSize: styledComponentTheme.fonts.sizes.Text4,
    iconFill: colors.white,
    iconBackgroundColor: colors.darkBlue,
    hintColor: colors.darkGrey
  },
  toggle: {
    trackOnColor: "#BD9298",
    trackOffColor: "#D8D8D8",
    thumbOnColor: "#7B2431",
    thumbOffColor: "#9B9B9B"
  }
});

const muiLabelStyle = {
  fontFamily: styledComponentTheme.fonts.family.bookText,
  fontWeight: styledComponentTheme.fonts.weight.bookText,
  fontSize: "12px",
  width: "initial"
};

const muiToggleStyle = {
  style: {
    width: "initial"
  },
  label: {
    fontFamily: styledComponentTheme.fonts.family.bookText,
    fontWeight: styledComponentTheme.fonts.weight.bookText
  }
};

export default styledComponentTheme;
export { materialUITheme, muiLabelStyle, muiToggleStyle, styledComponentTheme };



// WEBPACK FOOTER //
// ./src/common/theme.js